import React from 'react';
import {
  BodyText,
  Button,
  FlexColumn,
  FlexRow,
  SubtitleText,
  Textarea,
  formatHash,
  HashLength
} from '@make-software/cspr-design';
import styled from 'styled-components';

import { Message } from '@/entities';

export const FormTitle = styled(SubtitleText)(({ theme }) =>
  theme.withMedia({
    fontWeight: [600, 600, 700],
    fontSize: ['20px', '24px', '24px'],
  }),
);

export const StyledTextArea = styled(Textarea)(({ theme }) =>
  theme.withMedia({
    width: '100%'
  })
);

export const StyledButton = styled(Button)(({ theme }) =>
  theme.withMedia({
    cursor: 'pointer'
  })
);

interface ReadMessageFormProps {
  message: Message | null;
  decryptedMessage: string;
  onClose: () => void;
}

export const ReadMessageForm: React.FC<ReadMessageFormProps> = ({ message, decryptedMessage, onClose }) => {
  return (
    <FlexColumn gap={25}>
      <FormTitle size={1} scale='lg' variation='black'>
        Read Message
      </FormTitle>

      <FlexRow>
        <StyledTextArea
          value={decryptedMessage}
          label={
            <BodyText size={1} variation="black">
              From {formatHash(message?.senderPublicKey || '', HashLength.TINY)}
            </BodyText>
          }
          disabled
        />
      </FlexRow>

      <FlexRow gap={10}>
          {/*<StyledButton disabled>*/}
          {/*  Reply*/}
          {/*</StyledButton>*/}

          <StyledButton onClick={onClose}>
            Close
          </StyledButton>
      </FlexRow>
    </FlexColumn>
  );
};
